// extracted by mini-css-extract-plugin
var _1 = "assets-js-common-components-MegaNav-MegaNavVariant-components-LocalNav-components-Categories-Categories-module__active__LvBy9";
var _2 = "assets-js-common-components-MegaNav-MegaNavVariant-components-LocalNav-components-Categories-Categories-module__categoriesContainer__Ptxjn";
var _3 = "assets-js-common-components-MegaNav-MegaNavVariant-components-LocalNav-components-Categories-Categories-module__categoryLink__lFq8j";
export { _1 as "active", _2 as "categoriesContainer", _3 as "categoryLink" }
